import { styled } from '@mui/material/styles'
import Box from '@/components/common/Box'
import { colors, sizing, radius, spacing, skeletonOpacity } from '@/styles/designTokens'
import { skeletonPulse } from '@/styles/animations'

export const NavBarSkeleton = styled(Box)({
	display: 'flex',
	flexDirection: 'column',
	width: '100%',
	backgroundColor: colors.surfaceMuted,
})

export const SkeletonPill = styled(Box)({
	backgroundColor: colors.overlayLight,
	borderRadius: radius.pill,
	animation: `${skeletonPulse} 2.4s ease-in-out infinite`,
	'@media (prefers-reduced-motion: reduce)': {
		animation: 'none',
		opacity: skeletonOpacity.reduced,
	},
})

export const SearchBarRow = styled(Box)({
	display: 'flex',
	alignItems: 'center',
	gap: `${spacing.sm}px`,
	paddingLeft: `${spacing.lg}px`,
	paddingRight: `${spacing.lg}px`,
	paddingTop: `${spacing.lg}px`,
})

export const PillsRow = styled(Box)({
	display: 'flex',
	alignItems: 'center',
	gap: `${spacing.sm}px`,
	paddingLeft: `${spacing.lg}px`,
	paddingRight: `${spacing.lg}px`,
	paddingTop: `${spacing.md}px`,
	paddingBottom: `${spacing.sm}px`,
})

export const HamburgerPlaceholder = styled(SkeletonPill)({
	width: sizing.iconButton,
	height: sizing.iconButton,
	flexShrink: 0,
	borderRadius: radius.circle,
})

export const DesktopSpacer = styled(Box)({
	flex: '1 0 0',
})

export const DesktopSearchBarSkeleton = styled(SkeletonPill)({
	width: sizing.searchBarWidth,
	height: sizing.searchBarHeight,
	flexShrink: 0,
})
